export default [
  {
    /**
     * feature_id
     */
    feature_id: 1,
    /**
     * 标题
     */
    feature_title: '弹幕交织 光刃相接 高速机动下的陆空作战',
    /**
     * 标题图片
     * @modelAttrType image
     */
    title_img: require('./images/title1.png'),
    /**
     * 视频url
     */
    video_url: 'https://static-omni-mechabreak.seasungames.cn/uploads/202506/1749733550164_byzc.mp4',
    /**
     * 视频封面
     * @modelAttrType image
     */
    video_cover: require('./images/01.jpg')
  },
  {
    /**
     * feature_id
     */
    feature_id: 2,
    /**
     * 标题
     */
    feature_title: '搜索 清除 撒离 突入危险区域，解除世界危机',
    /**
     * 标题图片
     * @modelAttrType image
     */
    title_img: require('./images/title2.png'),
    /**
     * 视频url
     */
    video_url: 'https://static-omni-mechabreak.seasungames.cn/uploads/202506/1749733550164_jbDIY.mp4',
    /**
     * 视频封面
     * @modelAttrType image
     */
    video_cover: require('./images/02.jpg')
  },
  {
    /**
     * feature_id
     */
    feature_id: 3,
    /**
     * 标题
     */
    feature_title: '涂装改造 深度定制 每一处细节都交由你打造',
    /**
     * 标题图片
     * @modelAttrType image
     */
    title_img: require('./images/title3.png'),
    /**
     * 视频url
     */
    video_url: 'https://static-omni-mechabreak.seasungames.cn/uploads/202506/1749733550164_msmk.mp4',
    /**
     * 视频封面
     * @modelAttrType image
     */
    video_cover: require('./images/03.jpg')
  },
  {
    /**
     * feature_id
     */
    feature_id: 4,
    /**
     * 标题
     */
    feature_title: '定制驾驶员 巡游基地 战斗之余，体验驾驶员日常',
    /**
     * 标题图片
     * @modelAttrType image
     */
    title_img: require('./images/title4.png'),
    /**
     * 视频url
     */
    video_url: 'https://static-omni-mechabreak.seasungames.cn/uploads/202506/1749733550164_jxyDIY.mp4',
    /**
     * 视频封面
     * @modelAttrType image
     */
    video_cover: require('./images/04.jpg')
  }
];
